<template>
	<button class="ks-btn" :class="classes" :disabled="disabled || loading" v-on="computedListeners" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
		<span v-if="loading" class="ks-btn-loader"></span>
		<span :class="{ 'ks-btn-content-hidden': loading }">
			<k-icon v-if="icon && iconName" :size="size" :inherit="true" class="ks-btn-icon-label">{{ iconName }}</k-icon>
<!--			<span v-if="iconName" class="material-icons ks-icon ks-icon-inherit ks-btn-icon-label">{{ iconName }}</span>-->
			<slot></slot>
		</span>
	</button>
</template>

<script>
export default {
	props: {
		"disabled": {
			type: Boolean,
			default: false
		},
		"loading": {
			type: Boolean,
			default: false
		},
		"flat": {
			type: Boolean,
			default: false
		},
		"icon": {
			type: Boolean,
			default: false
		},
		"iconName": {
			type: String,
			default: ""
		},
		"outline": {
			type: Boolean,
			default: false
		},
		"block": {
			type: Boolean,
			default: false
		},
		"round": {
			type: Boolean,
			default: false
		},
		"size": {
			type: String,
			default: ""
		},
		"color": {
			type: String,
			default: ""
		},
		"noMargin": {
			type: Boolean,
			default: false
		},
		"to": {
			type: [String, Object],
			default: null
		},
		"href": {
			type: String,
			default: null
		},
		"target": {
			type: String,
			default: null
		},
		"active": {
			type: Boolean,
			default: false
		},
		"activeClass": {
			type: String,
			default: ""
		},
		"hoverClass": {
			type: String,
			default: ""
		},
		"noHover": {
			type: Boolean,
			default: false
		},
		"tile": {
			type: Boolean,
			default: false
		},
		"list": {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			isHovered: false
		}
	},
	computed: {
		"isRouteActive" () {
			if (!this.to || !this.$route) return false
			var target = typeof this.to === 'string' ? this.to : this.to.path || this.$router.resolve(this.to).route.path
			return this.$route.path === target || this.$route.path.startsWith(target + '/')
		},
		"computedListeners" () {
			var vm = this
			var listeners = Object.assign({}, this.$listeners)
			if (this.to) {
				listeners.click = function (e) {
					if (vm.$listeners.click) vm.$listeners.click(e)
					vm.$router.push(vm.to)
				}
			}
			if (this.href) {
				listeners.click = function (e) {
					if (vm.target) {
						window.open(vm.href, vm.target)
					} else {
						window.location.href = vm.href
					}
				}
			}
			return listeners
		},
		iconSmall () {
			console.log("SMALL ICON", this.size);
			return this.size === "small" || this.size === "xs" || this.size == "s" || this.size == "m";
		},
		"classes" () {
			var ret = {
				"ks-btn-transparent": this.flat,
				"ks-btn-icon": this.icon,
				"ks-btn-light-outline": this.outline,
				"ks-btn-block": this.block,
				"ks-btn-round": this.round,
				"ks-btn-loading": this.loading,
				"ks-btn-no-margin": this.noMargin,
				"ks-btn-no-hover": this.noHover,
				"ks-btn-tile": this.tile,
				"ks-btn-list": this.list
			}
			if (this.size != "") {
				ret["ks-btn-" + this.size] = true;
			}
			if (this.color != "") {
				var prefix = this.icon ? "ks-icon-btn-" : "ks-btn-";
				ret[prefix + this.color] = true;
			}
			if ((this.active || this.isRouteActive) && this.activeClass) {
				ret[this.activeClass] = true;
			} else if (this.active || this.isRouteActive) {
				ret["ks-btn-active"] = true;
			}
			if (this.hoverClass && this.isHovered) {
				ret[this.hoverClass] = true;
			}
			return ret;
		}
	},
	methods: {
		onMouseEnter () {
			this.isHovered = true
		},
		onMouseLeave () {
			this.isHovered = false
		}
	}
}
</script>

<style>
.ks-btn {
	margin: 2px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.ks-btn-no-hover:hover {
	background: inherit;
	color: inherit;
	border-color: inherit;
	box-shadow: none;
}
.ks-btn-tile {
	border-radius: 0;
}
.ks-btn-no-margin {
	margin: 0;
}

.ks-btn-icon-label {
	display: inline-flex;
	margin-right: 4px;
}
.ks-btn-icon-label:last-child {
	margin-right: 0;
}

.ks-btn-icon {
	padding: 0px;
  	padding-left: var(--ks-padding-1);

	border-radius: 4px;
	min-width: 0;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	background: transparent;
}
.ks-panel .ks-panel-heading .ks-panel-buttons .ks-btn-icon {
	padding: 0px;
	padding-left: var(--ks-padding-1);
}


.ks-btn-icon:hover {
	color: var(--ks-col-accent);
/*	background: var(--ks-grey-5);*/
}

.ks-btn-block {
	display: block;
	width: 100%;
}

.ks-btn-round {
	border-radius: 999em;
}
.ks-btn-list {
	width: 100%;
	text-align: left;
}
.ks-menu-content .ks-btn-list {
	justify-content: flex-start;
}


.ks-btn-loading {
	position: relative;
	pointer-events: none;
}
.ks-btn-loader {
	position: absolute;
	display: inline-block;
	width: 16px;
	height: 16px;
	border: 2px solid var(--ks-font-color);
	border-top-color: transparent;
	border-radius: 50%;
	animation: ks-btn-spin 0.6s linear infinite;
}
.ks-btn-content-hidden {
	visibility: hidden;
}

@keyframes ks-btn-spin {
	to { transform: rotate(360deg); }
}

.ks-btn-active {
	color: var(--ks-col-accent);
	background: inherit;
}
</style>